// src/components/PartnersStrip.jsx
import { useEffect, useState } from 'react'
import { collection, getDocs, orderBy, query, getDoc, doc } from '../services/mysqlStore'
import { db } from '../services/mysqlStore'

const css = `
  .partners-strip {
    padding: 36px 0 44px;
    background: #fff;
    border-top: 1px solid rgba(255,255,255,0.06);
    border-bottom: 1px solid rgba(255,255,255,0.06);
    overflow: hidden;
  }
  .partners-strip-label {
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #999;
    margin-bottom: 28px;
  }
  .partners-track-wrap {
    overflow: hidden;
    width: 100%;
    mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
    -webkit-mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
  }
  .partners-track {
    display: flex;
    align-items: center;
    gap: 60px;
    width: max-content;
    animation: partnersScroll 30s linear infinite;
  }
  .partners-track:hover { animation-play-state: paused; }
  .partner-logo-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    opacity: 0.45;
    filter: grayscale(1);
    transition: opacity .3s, filter .3s;
    text-decoration: none;
    cursor: default;
  }
  a.partner-logo-item { cursor: pointer; }
  .partner-logo-item:hover { opacity: 1; filter: grayscale(0); }
  .partner-logo-item img {
    height: 36px;
    width: auto;
    max-width: 120px;
    object-fit: contain;
    display: block;
  }
  .partner-logo-name {
    font-size: 11px;
    font-weight: 600;
    color: #555;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
  @keyframes partnersScroll {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
`

export default function PartnersStrip() {
  const [partners, setPartners]   = useState([])
  const [enabled, setEnabled]     = useState(null) // null = loading
  const [loading, setLoading]     = useState(true)

  useEffect(() => {
    const load = async () => {
      try {
        // Check if section is enabled
        const settingDoc = await getDoc(doc(db, 'siteSettings', 'partnersSection'))
        if (settingDoc.exists() && settingDoc.data().enabled === false) {
          setEnabled(false)
          setLoading(false)
          return
        }
        setEnabled(true)

        // Load partners
        const snap = await getDocs(query(collection(db, 'partners'), orderBy('createdAt', 'asc')))
        setPartners(snap.docs.map(d => ({ id: d.id, ...d.data() })))
      } catch (e) {
        // On error, show section (default behaviour)
        setEnabled(true)
        try {
          const snap = await getDocs(query(collection(db, 'partners'), orderBy('createdAt', 'asc')))
          setPartners(snap.docs.map(d => ({ id: d.id, ...d.data() })))
        } catch {}
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  // Still loading or disabled or no partners → render nothing
  if (loading || enabled === false || partners.length === 0) return null

  const items = partners.length < 6
    ? [...partners, ...partners, ...partners]
    : [...partners, ...partners]

  return (
    <section className="partners-strip">
      <style>{css}</style>
      <p className="partners-strip-label">Our Trusted Partners &amp; Suppliers</p>
      <div className="partners-track-wrap">
        <div className="partners-track">
          {items.map((p, i) =>
            p.url ? (
              <a key={i} href={p.url} target="_blank" rel="noopener noreferrer" className="partner-logo-item">
                <img src={p.logoUrl} alt={p.name} />
                <span className="partner-logo-name">{p.name}</span>
              </a>
            ) : (
              <div key={i} className="partner-logo-item">
                <img src={p.logoUrl} alt={p.name} />
                <span className="partner-logo-name">{p.name}</span>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  )
}
